module.exports = __webpack_public_path__ + "img/rns.82c1227c.png";